module.exports = __webpack_public_path__ + "static/media/visa.61389ed6.svg";